module.exports = __webpack_public_path__ + "img/pos7-bg.8acec580.jpg";